import styles from '../../assets/styles/Transactions/Transactions.module.scss';
import { MimaText, PageLoader, MimaButton } from '../../components';
import { downloadXlsx2 } from '../../utils/download';
import constant from '../../utils/constant';
import ExpenseDebt from './ExpenseDebt';
import Expenses from './Expenses';
import Income from './Income';
import moment from 'moment';
import React from 'react';

const RecentTransactions = ({
	allExpenseDebtTable,
	allIncomeTable,
	allExpensesTable,
	incomeTable,
	loading,
	expenseTable,
	refresh,
	expenseDebtTable,
	getUpdateDebtModal,
	transactions,
	goToEditIncomeModal,
	goToEditExpenseModal,
	filteredTransactions,
	setFilteredTransactions,
	setViewMoreExpense,
	setUpdateTransaction,
	setOpenTagModal,
	setViewMoreIncome,
}) => {
	const printData = filteredTransactions.map(transaction => ({
		Date: moment(transaction.createdAt).format('DD-MM-YYYY hh:mm'),
		Type: transaction.type,
		Customer: transaction.customer ? transaction.customer.fullname : '',
		Amount:
			transaction.type === constant.TRANSACTION_TYPE.EXPENSE ||
				transaction.type === constant.TRANSACTION_TYPE.EXPENSE_DEBT
				? `-${transaction.transactionAmount}`
				: transaction.transactionAmount || 0,
		Bank: transaction.bankName || '',
		currencyCode: transaction.currencyCode,
		category: transaction.category,
		walletBalance: transaction.walletBalance,
		AccountNumber:
			transaction.type === constant.TRANSACTION_TYPE.EXPENSE
				? transaction.receiverAccountNumber || ''
				: transaction.sourceAccountNumber || '',
		AccountName:
			transaction.type === constant.TRANSACTION_TYPE.EXPENSE
				? transaction.receiverAccountName || ''
				: transaction.sourceAccountName || '',
		Deposit:
			transaction.type === constant.TRANSACTION_TYPE.EXPENSE
				? `-${transaction.deposit}`
				: transaction.deposit || 0,
		ExpenseCategory: transaction.expenseCategory
			? transaction.expenseCategory.name
			: '',
		Narration: transaction.narration || '',

		Balance: transaction.balanceAmount,
		Status: transaction.status,
		'Paid Date': moment(transaction.paidDate).format('DD-MM-YYYY hh:mm'),
		'Due Date': moment(transaction.dueDate).format('DD-MM-YYYY hh:mm'),
		'Balance Due Date': moment(transaction.balanceDueDate).format(
			'DD-MM-YYYY hh:mm'
		),
	}));

	return (
		<div className={styles.recent}>
			<MimaText mt={4} variant="bodyBold" align="center">
				You are viewing{' '}
				{incomeTable ? 'Inflow' : expenseTable ? 'Outflow' : 'Debt'}{' '}
				Transactions{' '}
			</MimaText>

			<div className={styles.main_nav}>
				<div
					className={
						incomeTable ? styles.main_nav_item_active : styles.main_nav_item
					}
					onClick={allIncomeTable}>
					Inflow
				</div>
				<div
					className={
						expenseTable ? styles.main_nav_item_active : styles.main_nav_item
					}
					onClick={allExpensesTable}>
					Outflow
				</div>
				<div
					className={
						expenseDebtTable
							? styles.main_nav_item_active
							: styles.main_nav_item
					}
					onClick={allExpenseDebtTable}>
					Debt
				</div>
				<div
					className={styles.main_nav_item}
					onClick={() => {
						downloadXlsx2(printData, `Transactions`);
					}}>
					Download Report
				</div>
			</div>

			{loading ? (
				<PageLoader title="While we set things up for you" loading={loading} />
			) : (
				<>
					<MimaButton
						variant="filter"
						title="Refresh"
						onClick={refresh}
						width={10}
						mt={2}
					/>
					{incomeTable && (
						<Income
							transactions={transactions}
							goToEditIncomeModal={goToEditIncomeModal}
							setFilteredTransactions={setFilteredTransactions}
							filteredTransactions={filteredTransactions}
							setUpdateTransaction={setUpdateTransaction}
							setOpenTagModal={setOpenTagModal}
							setViewMoreIncome={setViewMoreIncome}
						/>
					)}
					{expenseTable && (
						<Expenses
							transactions={transactions}
							goToEditExpenseModal={goToEditExpenseModal}
							filteredTransactions={filteredTransactions}
							setFilteredTransactions={setFilteredTransactions}
							setViewMoreExpense={setViewMoreExpense}
							setUpdateTransaction={setUpdateTransaction}
						/>
					)}
					{/* {debtTable && <Debtors transactions={transactions} />} */}
					
					{expenseDebtTable && (
						<ExpenseDebt
							transactions={transactions}
							getUpdateDebtModal={getUpdateDebtModal}
							filteredTransactions={filteredTransactions}
							setFilteredTransactions={setFilteredTransactions}
						/>
					)}
				</>
			)}
		</div>
	);
};

export default RecentTransactions;
